import router from '@/router'
import ACCESS_ENUM from './accessEnum'
import checkAccess from './checkAccess'
import { useLoginUserStore } from '@/store/loginUser'

router.beforeEach(async (to, from, next) => {
  const loginUserStore = useLoginUserStore()
  const needAccess = to.meta?.access ?? ACCESS_ENUM.NOT_LOGIN

  // 目标页面需要登录才去获取用户信息，公开页面不触发 API 请求
  if (needAccess !== ACCESS_ENUM.NOT_LOGIN && loginUserStore.loginUser.userRole === ACCESS_ENUM.NOT_LOGIN) {
    await loginUserStore.getLoginUserInfo()
  }

  // 未登录或权限不足 → 跳转无权限页，不强制跳转登录页
  if (!checkAccess(loginUserStore.loginUser, needAccess)) {
    next('/noAuth')
    return
  }
  next()
})